import { Textarea } from "@/components/ui/textarea";

export function Block({ label, title, children, testId }) {
  return (
    <section id={testId} className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-6 sm:p-8 scroll-mt-24" data-testid={testId}>
      {label && <p className="font-mono-ui text-[11px] font-bold tracking-[0.25em] uppercase text-[#1A9AA8]">{label}</p>}
      {title && <h2 className="mt-2 text-xl sm:text-2xl font-bold tracking-tight text-[#0B2A4A]">{title}</h2>}
      <div className="mt-5">{children}</div>
    </section>
  );
}

export function FlowTable({ flow, showHost = false }) {
  return (
    <ol className="flex flex-col gap-4" data-testid="lesson-flow">
      {flow.map((r) => (
        <li key={`${r.time}-${r.host_action}`} className="grid md:grid-cols-[96px_1fr] gap-3 md:gap-6 border-l-4 border-[#F08A3C] bg-[#FAF6EE] rounded-r-xl p-4">
          <span className="font-mono-ui text-sm font-bold text-[#0B2A4A]">{r.time}</span>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
            {showHost && <div><dt className="text-[11px] font-bold uppercase tracking-wider text-[#D96F28]">Host action (host only)</dt><dd className="mt-1 text-slate-700">{r.host_action}</dd></div>}
            <div><dt className="text-[11px] font-bold uppercase tracking-wider text-[#147C88]">Teaching point</dt><dd className="mt-1 text-slate-700">{r.teach}</dd></div>
            <div><dt className="text-[11px] font-bold uppercase tracking-wider text-[#D96F28]">Class question</dt><dd className="mt-1 text-slate-800 font-medium">{r.ask}</dd></div>
            <div><dt className="text-[11px] font-bold uppercase tracking-wider text-[#147C88]">Student activity</dt><dd className="mt-1 text-slate-700">{r.do}</dd></div>
          </dl>
        </li>
      ))}
    </ol>
  );
}

function ChoiceField({ field, value, onChange, disabled, children }) {
  return (
    <fieldset className="flex flex-col gap-2" id={`answer-block-${field.id}`} data-testid={`answer-${field.id}`}>
      <legend className="text-sm font-semibold text-[#0B2A4A] mb-2">{field.prompt}</legend>
      <div className="grid sm:grid-cols-2 gap-2">
        {field.options.map((o) => {
          const on = value === o;
          return (
            <button key={o} type="button" role="radio" aria-checked={on} disabled={disabled} onClick={() => onChange(field.id, o)}
              className={`text-left rounded-xl border px-4 py-2.5 text-sm transition-colors disabled:opacity-70 ${on ? "bg-[#0B2A4A] text-white border-[#0B2A4A]" : "bg-[#FAF6EE]/60 border-[#0B2A4A]/15 text-[#0B2A4A] hover:bg-[#F5ECD7]"}`}
              data-testid={`answer-${field.id}-${o[0]}`}>{o}</button>
          );
        })}
      </div>
      {children}
    </fieldset>
  );
}

export function AnswerField({ field, value, onChange, disabled, rows = 3, children }) {
  if (field.options) return <ChoiceField field={field} value={value} onChange={onChange} disabled={disabled}>{children}</ChoiceField>;
  return (
    <div className="flex flex-col gap-2" id={`answer-block-${field.id}`}>
      <label htmlFor={`f-${field.id}`} className="text-sm font-semibold text-[#0B2A4A]">{field.prompt}</label>
      <Textarea id={`f-${field.id}`} rows={rows} value={value || ""} disabled={disabled} onChange={(e) => onChange(field.id, e.target.value)} className="bg-[#FAF6EE]/60" data-testid={`answer-${field.id}`} />
      {children}
    </div>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="flex flex-col gap-2.5 text-slate-700 leading-relaxed">
      {items.map((t) => (
        <li key={t} className="flex gap-3"><span className="mt-2.5 h-1.5 w-1.5 rounded-full bg-[#1A9AA8] shrink-0" /><span>{t}</span></li>
      ))}
    </ul>
  );
}
